import React from 'react';

import { Caption, Heading } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

type Props = {
  className?: string;
  cta?: React.ReactNode;
  illustration?: React.ReactNode;
  text?: string;
  title: string;
};

export function EmptyMessage({
  className,
  cta,
  illustration,
  text,
  title,
}: Props) {
  return (
    <div className={clsx(styles.wrapper, className)}>
      {illustration && (
        <div className={styles.illustration}>{illustration}</div>
      )}
      <Heading variant="sm" className={styles.title}>
        {title}
      </Heading>
      {text && <Caption variant="lg-regular">{text}</Caption>}
      {cta && <div className={styles.cta}>{cta}</div>}
    </div>
  );
}
